<template>
   <div>
      <div class="sous-titre">Récoltes {{ annee }}</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div class="my-card-row" v-else>
         <div class="my-card-container" v-for="recolte in recoltes" :key="recolte.id">
            <div class="my-card">
               <div class="my-card-header">{{ recolte.nom }}</div>
               <div class="my-card-content">{{ recolte.quantite }} KG</div>
               <div class="my-card-footer">
                  <span
                     style="font-weight:800"
                     :class="recolte.variation >= 0 ? 'success' : 'danger'"
                  >{{ recolte.variation >= 0 ? '+' : '' }}{{ recolte.variation }}%</span>
                  par rapport à
                  <strong>{{ annee - 1 }}</strong>
               </div>
            </div>
         </div>
      </div>

      <!-- // suivi des ruches  -->
      <div class="sous-titre">Suivi des ruches</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="my-card-row">
            <div class="dash-card-container">
               <div class="dash-card">
                  <div class="dash-card-header">Nourrissement à prévoir</div>
                  <div
                     class="text-center"
                     v-if="actions.nourrissement_a_prevoir.length == 0"
                  >Vous êtes à jour !</div>
                  <div v-else class="dash-card-table">
                     <div
                        class="dash-card-row"
                        v-for="ruche in actions.nourrissement_a_prevoir"
                        :key="ruche.id"
                        @click="
                           $router.push({
                              name: 'ruches.show',
                              params: { id: ruche.id }
                           })
                        "
                     >
                        <div>
                           <b-icon icon="chevron-right" size="is-small" />
                           {{ ruche.nom }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="dash-card-container">
               <div class="dash-card">
                  <div class="dash-card-header">Traitement à prévoir</div>
                  <div
                     class="text-center"
                     v-if="actions.traitement_a_prevoir.length == 0"
                  >Vous êtes à jour !</div>

                  <div v-else class="dash-card-table">
                     <div
                        class="dash-card-row"
                        v-for="ruche in actions.traitement_a_prevoir"
                        :key="ruche.id"
                        @click="
                           $router.push({
                              name: 'ruches.show',
                              params: { id: ruche.id }
                           })
                        "
                     >
                        <div>
                           <b-icon icon="chevron-right" size="is-small" />
                           {{ ruche.nom }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="dash-card-container">
               <div class="dash-card">
                  <div class="dash-card-header">Hausses à poser</div>
                  <div
                     class="text-center"
                     v-if="actions.hausses_a_poser.length == 0"
                  >Vous êtes à jour !</div>

                  <div class="dash-card-table">
                     <div
                        class="dash-card-row"
                        v-for="ruche in actions.hausses_a_poser"
                        :key="ruche.id"
                        @click="
                           $router.push({
                              name: 'ruches.show',
                              params: { id: ruche.id }
                           })
                        "
                     >
                        <div>
                           <b-icon icon="chevron-right" size="is-small" />
                           {{ ruche.nom }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- taches ******************* -->
      <!-- // suivi des ruches  -->
      <div class="sous-titre" style="margin-top:40px">Tâches apicoles</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div v-if="taches.length == 0" class="text-center">Vous êtes à jour !</div>
         <div class="my-card-row" v-else>
            <div class="dash-card-container" v-for="(ruche, index) in taches" :key="index">
               <div class="dash-card">
                  <div class="dash-card-header">{{ ruche.nom }}</div>
                  <div class="dash-card-table">
                     <div
                        class="dash-card-row"
                        v-for="tache in ruche.taches"
                        :key="tache.id"
                        @click="validerTache(tache.id, index)"
                     >
                        <div>
                           <b-icon icon="chevron-right" size="is-small" />
                           {{ tache.nom }}
                        </div>
                        <div>
                           <b-icon icon="check" type="is-success" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import { BeatLoader } from "@saeris/vue-spinners";
   export default {
      components: {
         BeatLoader
      },
      name: "Dashboard",
      data() {
         return {
            annee: new Date().getFullYear(),
            loading: true,
            recoltes: [],
            actions: [],
            taches: []
         };
      },
      mounted() {
         // Régler le titre
         this.$store.commit("setTitre", "Tableau de bord");
         this.getRecoltes();
      },
      methods: {
         async getRecoltes() {
            this.loading = true;
            let res = await axios.get("/dashboard");
            this.recoltes = res.data.recoltes;
            this.actions = res.data.actions;
            this.taches = res.data.taches;
            this.loading = false;
         },
         async validerTache(id, index) {
            this.$buefy.dialog.confirm({
               message:
                  "Souhaitez-vous vraiment marquer cette tâche comme faite ?",
               cancelText: "Non",
               title: "Confirmation",
               hasIcon: true,
               confirmText: "Oui",
               type: "is-success",
               onConfirm: () => {
                  axios.delete("/taches/" + id).then(res => {
                     if (res.data.erreur) {
                        this.$buefy.toast.open({
                           message: res.data.erreur,
                           type: "is-danger"
                        });
                     } else {
                        this.$buefy.toast.open({
                           message: "Tâche validée !",
                           type: "is-success"
                        });
                        this.taches[index].taches = this.taches[
                           index
                        ].taches.filter(tache => tache.id != id);
                     }
                  });
               }
            });
         }
      }
   };
</script>
